import { render, staticRenderFns, recyclableRender, components } from "./coupon-center.vue?vue&type=template&id=2e43bed3&scoped=true&"
var renderjs
import script from "./coupon-center.vue?vue&type=script&lang=js&"
export * from "./coupon-center.vue?vue&type=script&lang=js&"
import style0 from "./coupon-center.vue?vue&type=style&index=0&id=2e43bed3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e43bed3",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "shop/pages/coupon-center/coupon-center.vue"
export default component.exports